import { useRouter } from 'vue-router';
import { useIntercom } from '@/composables/useIntercom';
import { useStore } from '@/store';

type LogoutOptions = {
  beforeNavigate?: () => void;
};

export const useLogout = () => {
  const store = useStore();
  const router = useRouter();
  const { closeLiveSupport } = useIntercom();

  const logout = (options: LogoutOptions = {}) => {
    if (store.liveChatOpen) {
      closeLiveSupport();
    }
    options.beforeNavigate?.();
    router.replace('/logout');
  };

  return { logout };
};
